module.exports = __webpack_public_path__ + "static/media/wire4 (2).ebb75ef5.jpeg";